import { render } from "./BankTxnsFileModalForTxnViewPopup.vue?vue&type=template&id=673923b2&scoped=true"
import script from "./BankTxnsFileModalForTxnViewPopup.vue?vue&type=script&lang=js"
export * from "./BankTxnsFileModalForTxnViewPopup.vue?vue&type=script&lang=js"

import "./BankTxnsFileModalForTxnViewPopup.vue?vue&type=style&index=0&id=673923b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673923b2"]])

export default __exports__